import auth from '../middleware/auth';

export default {
    path: 'dokumenti/:documentId',
    name: 'single-document-view',
    meta: {
        middleware: [auth],
    },
    component: () => import('@/views/site/Document'),
}